// Shared classes for the "Cuenta" cards (Figma: Página de Perfil PRO).
export const cardClassName = "rounded-lg border border-[#a9b1bc] bg-[#fafafa] p-6";

export const cardTitleClassName = "min-w-0 flex-1 break-words text-2xl font-bold text-black";

export const outlineButtonClassName =
  "h-10 rounded-lg border-[#acbebe]/80 bg-white px-6 text-base text-black shadow-none";

export const primaryButtonClassName =
  "h-10 rounded-lg bg-black px-4 text-base text-white shadow-none hover:bg-black/85";

export const fieldGridClassName = "grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-x-6";

export const labelClassName = "mb-1 block text-sm text-[#7b7b7b]";

export const fieldClassName =
  "block min-h-10 w-full rounded-lg border border-[#a9b1bc] bg-white p-2 text-base text-black";

export const inputClassName = `${fieldClassName} focus:border-[#4f85f0] focus:outline-none focus:ring-1 focus:ring-[#4f85f0] disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500`;

export const errorClassName = "mt-1 text-sm text-red-600";
